import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TipsterShowcase from './components/TipsterShowcase';
import CTASection from './components/CTASection';
import PricingSection from './components/PricingSection';
import LiveOddsPreview from './components/LiveOddsPreview';

const SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      name: 'Apuestamente',
      description: 'Plataforma con estadísticas deportivas para apuestas en España y blogs deportivos. Comparador de cuotas en directo, ranking de tipsters verificados, ligas competitivas y gestor de bankroll personal.',
      inLanguage: 'es-ES',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/estadisticas?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      name: 'Apuestamente',
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      description: 'Plataforma con estadísticas deportivas para apuestas en España y blogs deportivos. Comparador de cuotas en directo, ranking de tipsters verificados, ligas competitivas y gestor de bankroll personal.',
      areaServed: { '@type': 'Country', name: 'España' },
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    document.title = 'Apuestamente —Estadisticas y blogs deportivos';
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    return () => { document.getElementById(id)?.remove(); };
  }, []);

  return (
    <div className="bg-[#0d0f14] min-h-screen">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <LiveOddsPreview />
      <TipsterShowcase />
      <CTASection />
      <PricingSection />
      <Footer />
    </div>
  );
}
